import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Crown from "@/components/Crown";
import ASSETS from "@/lib/assets";

const NAV_ITEMS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/programs", label: "Programs" },
  { to: "/coaching", label: "1:1 Coaching" },
  { to: "/freebie", label: "Free Resource" },
  { to: "/newsletter", label: "Newsletter" },
  { to: "/contact", label: "Contact" },
];

const Nav = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
  }, [open]);

  const isActive = (to) => (to === "/" ? pathname === "/" : pathname.startsWith(to));

  return (
    <>
      <nav className="nav" data-testid="site-nav">
        <div className="nav-inner">
          <Link to="/" className="nav-logo-link" aria-label="nijahAlmond home" data-testid="nav-logo">
            <img src={ASSETS.logo} alt="Nijah Almond" className="nav-logo-img" />
          </Link>
          <div className="nav-links">
            {NAV_ITEMS.slice(0, -1).map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`nav-link ${isActive(item.to) ? "active" : ""}`}
                data-testid={`nav-link-${item.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              >
                {item.label}
              </Link>
            ))}
          </div>
          <Link to="/contact" className="nav-cta" data-testid="nav-book-call">
            Submit Application →
          </Link>
          <button
            className="hamburger"
            aria-label="Open menu"
            onClick={() => setOpen((v) => !v)}
            data-testid="nav-hamburger"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </nav>

      <div className={`mobile-menu ${open ? "open" : ""}`} data-testid="mobile-menu">
        {NAV_ITEMS.map((item) => (
          <Link
            key={item.to}
            to={item.to}
            className={`mm-link ${isActive(item.to) ? "active" : ""}`}
            onClick={() => setOpen(false)}
            data-testid={`mm-link-${item.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
          >
            {item.label}
          </Link>
        ))}
        <Link to="/contact" className="btn btn-teal" style={{ marginTop: 16 }} onClick={() => setOpen(false)} data-testid="mm-book-call">
          <Crown size={14} color="#F3B21A" />
          Submit Your Application Now →
        </Link>
      </div>
    </>
  );
};

export default Nav;
